import assert from 'assert';
import { createLoggerFactory } from '@cvent/logging/LibraryLoggerFactory';
import { reportPendingFacts, factReporter, cventAnalyticsReporter, mockAnalyticsReporter, FactStore } from 'nucleus-analytics-middleware';
import mixpanelReporter from 'mixpanel-browser';
import { v4 } from 'uuid';
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { jsx } from '@emotion/react';
import Router, { useRouter } from 'next/router';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// eslint-disable-next-line import/no-unresolved
var loggerFactory = createLoggerFactory('react-analytics');

var PAGE_VIEW = 'PageView';
var ACTION = 'Action';

var _excluded$1 = ["id"];
var DEFAULT_VERSION$1 = '1.0';
/**
 * Convert fact to format Cvent Analytics understands.
 */

var mapFact$2 = function mapFact(_ref, baseProperties, definition) {
  var timestamp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Date.now();
  var cventAnalyticsTypes = arguments.length > 4 ? arguments[4] : undefined;

  _ref.id;
      var data = _objectWithoutProperties(_ref, _excluded$1);

  var baseMapping = _objectSpread2(_objectSpread2({}, baseProperties), {}, {
    name: definition.id,
    ts: timestamp,
    ver: definition.ver || DEFAULT_VERSION$1,
    data: data
  });

  switch (definition.type) {
    case PAGE_VIEW:
      return _objectSpread2(_objectSpread2({}, baseMapping), {}, {
        type: (cventAnalyticsTypes === null || cventAnalyticsTypes === void 0 ? void 0 : cventAnalyticsTypes.pageView) || definition.type,
        page: definition.name,
        pageEntityId: data[definition.objectIdAttribute] || baseProperties[definition.objectIdAttribute] || null
      });

    case ACTION:
      return _objectSpread2(_objectSpread2({}, baseMapping), {}, {
        type: (cventAnalyticsTypes === null || cventAnalyticsTypes === void 0 ? void 0 : cventAnalyticsTypes.action) || definition.type,
        action: definition.name
      });

    default:
      return _objectSpread2(_objectSpread2({}, baseMapping), {}, {
        type: definition.type,
        action: definition.name
      });
  }
};

// nucleus-analytics-middleware handles debouncing and batching fact publication
/**
 * Initialize reporter and fact store
 * Returns an object with `track(fact)` function
 */

var cventAnalytics = function cventAnalytics(analyticsReporter, factStore, cventAnalyticsTypes) {
  var config = {
    analyticsReporter: analyticsReporter
  }; // use debounced function builder from nucleus-analytics

  var reportPendingFactsCallback = reportPendingFacts(factStore, config);
  return {
    track: function track(fact, baseProperties, definition, timestamp) {
      var mapped = mapFact$2(fact, baseProperties, definition, timestamp, cventAnalyticsTypes);
      factReporter(mapped, factStore, config, reportPendingFactsCallback);
      return mapped;
    }
  };
};

var mapFact$1 = function mapFact(fact, baseProperties, _ref) {
  var name = _ref.name,
      type = _ref.type;
  return _objectSpread2(_objectSpread2({
    name: name,
    type: type
  }, baseProperties), fact);
};

var LOG$2 = loggerFactory.create('Analytics.mixpanel');

var mixpanel = function mixpanel() {
  return {
    track: function track(fact, baseProperties, definition) {
      var mapped = mapFact$1(fact, baseProperties, definition); // Verify that mixpanelReporter has a config property,
      // it only gets set when mixpanel has been initialized
      // covers when mixpanel is not initialized by the consuming app

      if (typeof window !== 'undefined' && mixpanelReporter !== null && mixpanelReporter !== void 0 && mixpanelReporter.config) {
        mixpanelReporter.track(definition.name, mapped);
      } else {
        LOG$2.info('Mocked Mixpanel Fact:', mapped);
      }

      return mapped;
    }
  };
};

var version = "5.0.1";

var _excluded = ["id"];
var TYPE = 'aa_attendee_activities';
var DEFAULT_VERSION = '1.0';
var ATTENDEE_TYPE_INVITEE = 'core.invitee';
var ATTENDEE_TYPE_GUEST = 'core.freeloader'; // Remove null or undefined properties

var cleanObject = function cleanObject(obj) {
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value != null) {
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, value));
    }

    return acc;
  }, {});
};

var mapFact = function mapFact(_ref3, baseProperties, definition) {
  var timestamp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Date.now();

  _ref3.id;
      var data = _objectWithoutProperties(_ref3, _excluded);

  return {
    type: TYPE,
    time: timestamp,
    ts: timestamp,
    environment: baseProperties.environment,
    activity_id: v4(),
    account_mapping_id: baseProperties.accountMappingId,
    account_id: baseProperties.accountMappingId,
    accountId: baseProperties.accountMappingId,
    attendee_type: baseProperties.guest ? ATTENDEE_TYPE_GUEST : ATTENDEE_TYPE_INVITEE,
    attendee_id: baseProperties.attendeeId,
    activity_type: definition.activityType,
    schema_version: definition.ver || DEFAULT_VERSION,
    event_id: baseProperties.eventId,
    event_name: baseProperties.eventName,
    object_id: data[definition.objectIdAttribute] || baseProperties[definition.objectIdAttribute],
    data: cleanObject(_objectSpread2({
      platform: baseProperties.platform,
      app_version: baseProperties.appVersion,
      library_version: version
    }, data))
  };
};

/**
 * Maps and tracks a fact for AttendeeActivities
 * https://wiki.cvent.com/x/aj31Bw
 */
var LOG$1 = loggerFactory.create('Analytics.attendeeActivities');
var SNAKE_CASE = /^[a-z]+(_[a-z]+)*\.[a-z]+(_[a-z]+)*$/;
var CAMEL_CASE = /^[a-z][A-Za-z]*\.[a-z][A-Za-z]*$/;
var validateDefinition = function validateDefinition(definition) {
  assert(definition.activityType, 'AttendeeActivities fact must include an activityType');
  assert(SNAKE_CASE.test(definition.activityType) || CAMEL_CASE.test(definition.activityType), 'AttendeeActivities fact must have valid activityType of form <object>.<action>');
};
var requiredBaseProperties = ['accountMappingId', 'attendeeId', 'eventId', 'environment'];
var verifyFact = function verifyFact(fact, baseProperties, definition) {
  if (definition.objectIdAttribute && fact[definition.objectIdAttribute] === undefined && baseProperties[definition.objectIdAttribute] === undefined) {
    LOG$1.warn('Fact or baseProperties is missing objectIdAttribute', fact);
    return false;
  }

  var hasRequiredBaseProperties = requiredBaseProperties.every(function (requiredProp) {
    if (baseProperties[requiredProp] == null) {
      LOG$1.warn("baseProperties missing field ".concat(requiredProp), baseProperties);
      return false;
    }

    return true;
  });
  return hasRequiredBaseProperties;
};
var getIncludedAttributesFromDefinition = function getIncludedAttributesFromDefinition(definition) {
  return [definition.objectIdAttribute];
};

var attendeeActivities = function attendeeActivities(analyticsReporter, factStore) {
  return {
    track: function track(fact, baseProperties, definition, timestamp) {
      var mapped = mapFact(fact, baseProperties, definition, timestamp);
      factReporter(mapped, factStore, {
        analyticsReporter: analyticsReporter
      });
      return mapped;
    }
  };
};

var LOG = loggerFactory.create('Analytics');
var supportedDestinations = ['Mixpanel', 'Analytics', 'AttendeeActivities'];
/**
 * Verifies a fact definition includes the minimum info
 */

var verifyFactDefinition = function verifyFactDefinition(definition) {
  assert(definition, 'fact definition cannot be null');

  if (definition.type === PAGE_VIEW) {
    assert(definition.path, 'PageView fact definition must include a path');
  } else {
    assert(definition.id, 'fact definition requires an id');
  }

  assert(definition.name, 'fact definition requires a name');
  assert(definition.type, 'fact definition requires a type');
  assert(definition.destinations, 'fact definition requires a destination array');
  assert(definition.destinations.length > 0, 'fact definition requires at least one destination');

  if (definition.destinations.includes('AttendeeActivities')) {
    validateDefinition(definition);
  }

  return definition;
};
/**
 * https://wiki.cvent.com/x/ImNyDg
 * Analytics module that handles defining facts and tracking them
 * against various destinations.
 */


var Analytics = /*#__PURE__*/function () {
  function Analytics(config, factDefinitions) {
    var _this = this;

    var baseProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Analytics);

    /**
     * Configuration values
     */
    this.config = config;
    /**
     * Map of Action definitions by id for faster lookup
     */

    this.factDefinitions = new Map();
    /**
     * Map of PageView definitions by path for faster lookup
     */

    this.pageViewFactDefinitions = new Map();
    this.pageViewData = new Map();
    factDefinitions.forEach(function (factDefinition) {
      verifyFactDefinition(factDefinition);

      if (factDefinition.type === PAGE_VIEW) {
        _this.pageViewFactDefinitions.set(factDefinition.path, factDefinition);
      } else {
        _this.factDefinitions.set(factDefinition.id, factDefinition);
      }
    });
    /**
     * Properties that will get sent with every fact
     */

    this.baseProperties = baseProperties; // Shared nucleus-analytics-middleware config

    var _ref = config.cventAnalytics || {},
        url = _ref.url;

    var analyticsReporter = url ? cventAnalyticsReporter(url) : mockAnalyticsReporter();
    var factStore = new FactStore();

    var _ref2 = config.cventAnalytics || {},
        cventAnalyticsTypes = _ref2.cventAnalyticsTypes;
    /**
     * Destination modules
     */


    this.cventAnalytics = cventAnalytics(analyticsReporter, factStore, cventAnalyticsTypes);
    this.attendeeActivities = attendeeActivities(analyticsReporter, factStore);
    this.mixpanel = mixpanel(config.mixpanel);
  }

  _createClass(Analytics, [{
    key: "replaceBaseProperties",
    value: function replaceBaseProperties(properties) {
      this.baseProperties = properties;
    }
  }, {
    key: "updateBaseProperties",
    value: function updateBaseProperties(properties) {
      this.baseProperties = _objectSpread2(_objectSpread2({}, this.baseProperties), properties);
    }
    /**
     * Verifies a fact against it's definition
     * Returns the fact with only defined attributes
     */

  }, {
    key: "verifyFact",
    value: function verifyFact$1(fact, definition) {
      var _definition$attribute = definition.attributes,
          attributes = _definition$attribute === void 0 ? [] : _definition$attribute;
      var missingAttributes = attributes.filter(function (attribute) {
        return fact[attribute] === undefined;
      });
      var failIfMissingAttributes = this.config.hasOwnProperty('failIfMissingAttributes') ? this.config.failIfMissingAttributes : true;

      if (missingAttributes.length > 0 && failIfMissingAttributes) {
        LOG.warn("Fact has missing attributes: ".concat(missingAttributes.join(', '), "."), {
          fact: fact
        });
        return false;
      }

      var includedAttributes = attributes;

      if (definition.destinations.includes('AttendeeActivities')) {
        if (!verifyFact(fact, this.baseProperties, definition)) {
          return false;
        }

        includedAttributes = [].concat(_toConsumableArray(attributes), _toConsumableArray(getIncludedAttributesFromDefinition(definition)));
      } // Pick only attributed properties


      var pickOnlyAttributedProps = this.config.hasOwnProperty('pickOnlyAttributedProps') ? this.config.pickOnlyAttributedProps : true;
      return !pickOnlyAttributedProps ? fact : includedAttributes.reduce(function (acc, attribute) {
        return fact[attribute] !== undefined ? _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, attribute, fact[attribute])) : acc;
      }, {});
    }
    /**
     * If fact has path check page view definitions, otherwise regular fact map by id
     */

  }, {
    key: "getDefinitionByFact",
    value: function getDefinitionByFact(fact) {
      var definition;

      if (fact.path) {
        definition = this.pageViewFactDefinitions.get(fact.path);
      }

      return definition || this.factDefinitions.get(fact.id);
    }
    /**
     * Publishes a fact to the destinations defined in the fact definition
     * Returns false if publishing fails, true otherwise
     */

  }, {
    key: "track",
    value: function track(fact) {
      var _this2 = this;

      var definition = this.getDefinitionByFact(fact);

      if (!definition) {
        LOG.warn('No definition matching fact', fact);
        return false;
      }

      var pageViewData;

      if (definition.type === PAGE_VIEW) {
        pageViewData = this.pageViewData.get(definition.path);
      }

      var verifiedFact = this.verifyFact(_objectSpread2(_objectSpread2({}, pageViewData), fact), definition);

      if (verifiedFact) {
        var timestamp = Date.now();

        if (this.config.timestampOffset) {
          timestamp = timestamp + this.config.timestampOffset;
        }

        definition.destinations.forEach(function (destination) {
          if (supportedDestinations.includes(destination)) {
            _this2["track".concat(destination)](verifiedFact, definition, timestamp);
          }
        });
        return true;
      }

      return false;
    }
    /**
     * Track to Mixpanel
     */

  }, {
    key: "trackMixpanel",
    value: function trackMixpanel(fact, definition, timestamp) {
      return this.mixpanel.track(fact, this.baseProperties, definition, timestamp);
    }
    /**
     * Track to Cvent Analytics service
     */

  }, {
    key: "trackAnalytics",
    value: function trackAnalytics(fact, definition, timestamp) {
      return this.cventAnalytics.track(fact, this.baseProperties, definition, timestamp);
    }
    /**
     * Track to Attendee Activities
     */

  }, {
    key: "trackAttendeeActivities",
    value: function trackAttendeeActivities(fact, definition, timestamp) {
      return this.attendeeActivities.track(fact, this.baseProperties, definition, timestamp);
    }
  }]);

  return Analytics;
}();

var NOT_INITIALIZED = 'analytics context not initialized';
var mockAnalytics = {
  track: function track() {
    return NOT_INITIALIZED;
  },
  replaceBaseProperties: function replaceBaseProperties() {
    return NOT_INITIALIZED;
  },
  updateBaseProperties: function updateBaseProperties() {
    return NOT_INITIALIZED;
  }
};
var AnalyticsContext = /*#__PURE__*/createContext(mockAnalytics);
var useAnalytics = function useAnalytics() {
  return useContext(AnalyticsContext);
};
/**
 * Provides a context for tracking analytics.
 */

var AnalyticsProvider = function AnalyticsProvider(_ref) {
  var children = _ref.children,
      config = _ref.config,
      factDefinitions = _ref.factDefinitions,
      baseProperties = _ref.baseProperties;

  var _useState = useState(mockAnalytics),
      _useState2 = _slicedToArray(_useState, 2),
      analytics = _useState2[0],
      setAnalytics = _useState2[1];

  useEffect(function () {
    setAnalytics(new Analytics(config, factDefinitions, baseProperties)); // Initialize this only once
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    analytics.updateBaseProperties(baseProperties);
  }, [analytics, baseProperties]);
  return jsx(AnalyticsContext.Provider, {
    value: analytics
  }, children);
};

/**
 * Tracks each pathname change.
 * Ensure PageView definition exists.
 * Set in application wrapper.
 *
 * @param {Object} {
 *  @param {Array<string>} exclude Array of excludeed routes we shouldn't track
 * }
 */

var useRouterTracking = function useRouterTracking() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$exclude = _ref.exclude,
      exclude = _ref$exclude === void 0 ? [] : _ref$exclude;

  var analytics = useAnalytics();

  var _useRouter = useRouter(),
      pathname = _useRouter.pathname;

  useEffect(function () {
    // Track path on first load
    if (pathname && !exclude.includes(pathname)) {
      analytics.track({
        path: pathname
      });
    }
  }, [analytics]); // eslint-disable-line react-hooks/exhaustive-deps

  var onRouteChange = useCallback(function () {
    if (!exclude.includes(pathname)) {
      analytics.track({
        path: pathname
      });
    }
  }, [pathname, analytics, exclude]);
  useEffect(function () {
    var _Router$events;

    // eslint-disable-next-line no-unused-expressions
    (_Router$events = Router.events) === null || _Router$events === void 0 ? void 0 : _Router$events.on('routeChangeComplete', onRouteChange);
    return function () {
      var _Router$events2;

      // eslint-disable-next-line no-unused-expressions
      (_Router$events2 = Router.events) === null || _Router$events2 === void 0 ? void 0 : _Router$events2.off('routeChangeComplete', onRouteChange);
    };
  }, [onRouteChange]);
};

var RouterTracking = function RouterTracking(_ref2) {
  var _ref2$exclude = _ref2.exclude,
      exclude = _ref2$exclude === void 0 ? [] : _ref2$exclude;
  useRouterTracking({
    exclude: exclude
  });
  return null;
};

/**
 * Mapping functions for mapping a fact to the appropriate destination.
 *
 * function mapFact(fact: Object, baseProperties: Object, definition: Object): Object
 */

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  mapMixpanelFact: mapFact$1,
  mapCventAnalyticsFact: mapFact$2,
  mapAttendeeActivitiesFact: mapFact
});

export { ACTION, Analytics, AnalyticsContext, AnalyticsProvider, PAGE_VIEW, RouterTracking, loggerFactory, index as mapping, useAnalytics };
//# sourceMappingURL=index.js.map
